export default __webpack_public_path__ + "static/media/reglogin-m-bg-bm.46e17513.webp";